<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="skeleton__wrapper">
    <div class="container">
      <div class="row lg:mb-6">
        <div class="col-12 lg:mt-4">
          <CiSkeletonItem class="mx-auto mb-4 block h-[130px] py-12 lg:mx-0 lg:mt-2 lg:h-5 lg:w-[70%] lg:py-0" />
        </div>
      </div>

      <div class="row rating-row !mt-[-45px] lg:!mt-0">
        <div class="col-12 col-lg-2">
          <div class="row">
            <div class="col-4 offset-4 col-lg-10 offset-lg-1">
              <CiSkeletonItem
                class="m-0 h-auto w-full rounded-full pt-[100%] md:ml-[10%] md:w-4/5 md:pt-[80%] lg:m-0 lg:size-[95px] lg:pt-0 xl:size-[120px]"
              />
            </div>
            <div class="col-12 mt-6 lg:mt-0">
              <CiSkeletonItem class="mx-auto my-0 h-5 w-1/2 lg:my-[2px] lg:w-4/5" />
              <CiSkeletonItem class="mx-auto h-5 w-1/2 lg:my-[2px] lg:w-4/5" />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-10 order-1 hidden items-end lg:order-2 lg:mt-6 lg:flex">
          <div class="row w-full">
            <div class="col-12">
              <CiSkeletonItem class="h-10 w-[70%]" />
            </div>
          </div>
        </div>
      </div>

      <div class="row my-12">
        <div class="col-12">
          <CiSkeletonItem class="h-[400px] w-full" />
          <CiSkeletonItem class="h-[400px] w-full lg:mt-6" />
          <CiSkeletonItem class="h-[400px] w-full lg:mt-6" />
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
